var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.theShop.id))]),_c('td',[_vm._v(_vm._s(_vm.theShop.name))]),_c('td',[_vm._v(_vm._s(_vm.theShop.mobile))]),_c('td',[_c('button',{staticClass:"purple-btn ml-2",on:{"click":_vm.verify}},[_vm._v("تأیید")])])])}
var staticRenderFns = []

export { render, staticRenderFns }